import { login, accountinfo, home, activity } from '@/api'
import { Message } from 'element-ui'
import VueCookie from 'vue-cookie'
import router from '@/router'
import { base64 } from '../utils/index'
const actions = {
  // 获取资金管理类表
  getFundsAuth({ commit, state }, homeGoFunds) {
    let listType = state.listType
    if (listType == 0) {
      if (homeGoFunds) {
        router.push({
          path: '/deposit',
        })
      }
    } else {
      let params = {
        pagePlatformType: 'PC',
      }
      login.getGoldPageList(params).then(res => {
        if (res.IsSuccess) {
          commit('setFundsAuth', res.Data)
          if (homeGoFunds) {
            let flag = 0
            for (const iterator of res.Data) {
              //&& !(iterator.isFirst=='0' && iterator.pageName=='网上支付')
              if (
                iterator.pageStatus == 0 &&
                flag != 1 &&
                ((iterator.isFirst == '1' && iterator.isFirstStatus == '0') || (iterator.isFirst == '0' && iterator.notFirstStatus == '0'))
              ) {
                let label = iterator.pageName
                if (label === '充值码支付') {
                  label = '商城支付'
                }
                for (const leftItem of state.leftList[3].children) {
                  if (new RegExp(label).test(leftItem.meta.title)) {
                    flag = 1
                    router.push({
                      path: leftItem.path,
                    })
                  }
                }
              }
            }
          }
        }
      })
    }
  },
  // 登录切换判断拥有账户
  async switch({ commit }) {
    let type = JSON.parse(base64.decode(localStorage.getItem('I'))).type == 1 ? 0 : 1
    let res = await login.switch({ type })
    if (res.IsSuccess) {
      if (type == '0') {
        commit('setAccountType', 2)
        commit('setListType', 1)
        // 真实账户切换到模拟后需要再次切换回去
        await login.switch({ type: 1 })
      } else if (type == '1') {
        commit('setAccountType', 2)
        commit('setListType', 1)
        // 如果是为模拟账户切换有真实账户  则设置role
        if (res.Data.jfAccount.role) {
          commit('setUserRole', res.Data.jfAccount.role)
        }
      }
    } else {
      if (type == '0') {
        commit('setAccountType', 1)
        commit('setListType', 1)
      } else if (type == '1') {
        commit('setAccountType', 0)
        commit('setListType', 0)
      }
    }
  },
  // 资金管理权限判断
  fundsStatus({ state }, text) {
    for (let authItem of state.fundsAuth) {
      let label = authItem.pageName
      if (label === '充值码支付') {
        label = '商城支付'
      }
      if (new RegExp(label).test(text)) {
        let params = {
          id: authItem.id,
        }
        login
          .checkGoldPageList(params)
          .then(res => {
            if (res.IsSuccess) {
              if (res.Data.pageStatus === '1') {
                authF(state, '权限变动，请重新操作')
              }
            } else {
              authF(state, '获取权限错误，请重新登录')
            }
          })
          .catch(res => {
            authF(state, '获取权限错误，请重新登录')
          })
      }
    }
  },
  async getUserInfo({ commit }, params) {
    let res = {}
    //真实用户
    if (params.type === 1) {
      res = await accountinfo.getIdentityInfo()
    } else {
      //模拟用户
      res = await accountinfo.getSimulatorInfo()
    }
    if (res.IsSuccess) {
      if (!res.Data.account) {
        res.Data.account = res.Data.simulatorAccount
      }
      if (params.isSetTypeOrRole == 1) {
        commit('setListType', 1)
        commit('setUserRole', res.Data.jfUser.role)
      }
      commit('setUserInfo', Object.assign({}, res.Data, params))
    }
  },
  async getBanner({ commit }, params) {
    let res = {}
    res = await home.getBannerApi(params)
    if (res.IsSuccess) {
      let banner = {
        home: [],
        firstCharge: {},
      }
      let banners = []
      res.Data.forEach(item => {
        if (item.status && item.type === '22') {
          //首页banner
          banner.home.push(item)
        }
        if (item.status && item.type === '24') {
          //首冲活动banner
          banner.firstCharge = item
        }
        if (item.status && item.type === '25') {
          //服务中心-联系我们banner
          banner.contact = item
        }
        if (item.status && item.type === '34') {
          //台湾首冲活动banner
          banner.twcontact = item
        }
        if (item.status && item.type === '36') {
          //交易有奖活动banner
          banner.cont_jy = item
        }
      })
      commit('setBannerInfo', banner)
    }
  },
}

function authF(state, text) {
  if (state.userRole == 4 || state.userRole == 5 || /www.prowayfx/.test(window.location.origin) || /www.prowayxau/.test(window.location.origin)) {
    // let clientid = localStorage.getItem('clientid')
    // localStorage.clear();
    // localStorage.setItem('clientid', clientid);
    // window.location.href = '/login'
    router.push({
      path: '/login',
      replace: true,
    })
    setTimeout(() => {
      window.location.reload()
    }, 2000)
  } else {
    VueCookie.delete('remember')
    let clientid = localStorage.getItem('clientid')
    localStorage.clear()
    localStorage.setItem('clientid', clientid)
    router.push({
      path: '/login',
      replace: true,
    })
  }

  Message.error({
    message: text,
  })
}
export default actions



// WEBPACK FOOTER //
// ./src/store/actions.js